import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { size } from 'underscore';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private cookieService: CookieService, private router: Router) {}

  authenticated: BehaviorSubject<any>;
  jwtHelper: JwtHelperService = new JwtHelperService();

  setAccessToken(token: string): void {
    const domain = environment.production ? '.sandbox.co.in' : 'localhost';
    this.cookieService.set('SESSIONID', token, 1, '/', domain, true, 'Strict');
  }

  getAccessToken(): string {
    return this.cookieService.get('SESSIONID');
  }
  
  clearSession(): void {
    const domain = environment.production ? '.sandbox.co.in' : 'localhost';
    this.cookieService.delete('SESSIONID', '/', domain, true, 'Strict');
    this.cookieService.delete('REFRESHSESSIONID', '/', domain, true, 'Strict');
  }

  clearSessionAndRedirectToLogin(redirectParam?: string): void {
    this.clearSession();
    this.redirectToLogin(redirectParam);
  }

  redirectToLogin(redirectParam?: string): void {
    const queryParams = redirectParam ? { redirect: redirectParam } : {};
    this.router.navigate(['/login'], { queryParams });
  }

  getUsername(): string | null {
    if (this.getAccessToken() != null && this.getAccessToken() != '') {
      let jwtToken = this.jwtHelper.decodeToken(this.getAccessToken());
      return jwtToken['username'];
    }
    return null;
  }

  getIssuer(): string | null {
    if (this.getAccessToken() != null && this.getAccessToken() != '') {
      let jwtToken = this.jwtHelper.decodeToken(this.getAccessToken());
      return jwtToken['iss'];
    }
    return null;
  }

  isAuthenticated(): boolean {
    try {
      if (this.getAccessToken() != null) {
        let token = this.getAccessToken().split('.');
        if (
          token &&
          size(token) == 3 &&
          this.jwtHelper.decodeToken(this.getAccessToken()) &&
          !this.jwtHelper.isTokenExpired(this.getAccessToken()) &&
          this.getIssuer()?.includes(environment.token_issuer)
        ) {
          return true;
        }
      }
    } catch (error) {
      return false;
    }
    return false;
  }
}

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  authentication_host: string;
  constructor(public auth: AuthService) {
    this.authentication_host = environment.authentication_host
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.isAuthenticated()) {
      request = request.clone({
        setHeaders: {
          authorization: this.auth.getAccessToken(),
        },
      });
    } else {
      window.location.href = this.authentication_host;
    }
    return next.handle(request);
  }
}

